import { IStorageController } from "./istorage-controller";
import { ITemplate, IDictionary } from "../../../typings";

export default class MemoryStorageController implements IStorageController {
  STORAGE_TEMPLATE: ITemplate;
  STORAGE_OUTPUT_TEMPLATE: ITemplate;
  STORAGE_UNIT_SYSTEM: string;
  STORAGE_DECIMAL: "," | ".";
  private updated: boolean;
  saveOutputTemplateAsync(): void {}

  getTemplate(): ITemplate {
    return this.STORAGE_TEMPLATE;
  }

  saveTemplate(template: ITemplate): void {
    this.STORAGE_TEMPLATE = template;
  }

  hasTemplate(): boolean {
    if (this.STORAGE_TEMPLATE) {
      return true;
    }
    return false;
  }

  getOutputTemplate(): ITemplate {
    return this.STORAGE_OUTPUT_TEMPLATE;
  }

  saveOutputTemplate(output: ITemplate): void {
    this.STORAGE_OUTPUT_TEMPLATE = output;
  }

  hasOutputTemplate(): boolean {
    if (this.STORAGE_OUTPUT_TEMPLATE) {
      return true;
    }
    return false;
  }

  getUpdated(): boolean {
    if (typeof this.updated === "undefined") {
      return false;
    }

    return this.updated;
  }

  setUpdated(updated: boolean): void {
    this.updated = updated;
  }

  clearCache(): void {
    delete this.STORAGE_TEMPLATE;
    delete this.STORAGE_OUTPUT_TEMPLATE;
    delete this.STORAGE_UNIT_SYSTEM;
  }
}
